import ResultsNew from "../ResultsNew";

function ResultMobile() {
    document.body.classList.add("variant-mobile-results");
    return ResultsNew()
}

export default ResultMobile;